import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const NeighborhoodList = ({ neighborhoods, serviceType = "lava-jato" }) => {
  const slugify = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-');
  };

  // Destacar os 6 bairros específicos solicitados
  const featuredNeighborhoodNames = [
    'Jardim Bela Vista',
    'Parque das Laranjeiras', 
    'Parque Atheneu',
    'Jardim Mariliza',
    'Alto da Glória',
    'Vila Redenção'
  ];
  
  const featuredNeighborhoods = featuredNeighborhoodNames
    .map(name => neighborhoods.find(n => n === name))
    .filter(Boolean);
  
  const otherNeighborhoods = neighborhoods.filter(
    n => !featuredNeighborhoodNames.includes(n)
  );

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00B4D8]/10 rounded-full px-4 py-2 mb-4">
            <MapPin className="w-4 h-4 text-[#00B4D8]" />
            <span className="text-[#00B4D8] text-sm font-semibold">COBERTURA COMPLETA</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            <span className="text-[#00B4D8]">Localização Privilegiada</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Serviços de qualidade premium de fácil acesso próximo a diversos bairros de Goiânia e Aparecida de Goiânia
          </p>
        </div>
        
        {/* Featured Neighborhoods - Destaque */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 max-w-6xl mx-auto">
          {featuredNeighborhoods.map((neighborhood) => (
            <Link
              key={neighborhood}
              to={`/${serviceType}-${slugify(neighborhood)}`}
              className="group relative bg-white rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#00B4D8] overflow-hidden"
            >
              {/* Decorative Circle */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#00B4D8]/5 rounded-full -mr-16 -mt-16 group-hover:bg-[#00B4D8]/10 transition-colors"></div>
              
              <div className="relative z-10">
                <div className="flex items-center justify-between mb-3">
                  <div className="w-12 h-12 bg-[#00B4D8]/10 rounded-full flex items-center justify-center group-hover:bg-[#00B4D8] group-hover:scale-110 transition-all duration-300">
                    <MapPin className="w-6 h-6 text-[#00B4D8] group-hover:text-white" />
                  </div>
                  <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-[#00B4D8] group-hover:translate-x-1 transition-all" />
                </div>
                
                <h3 className="text-lg font-bold text-gray-900 group-hover:text-[#00B4D8] transition-colors">
                  {neighborhood}
                </h3>
                <p className="text-sm text-gray-500 mt-1">
                  Ver serviços disponíveis
                </p>
              </div>
            </Link>
          ))}
        </div>
        
        {/* Other Neighborhoods - Compact Grid */}
        {otherNeighborhoods.length > 0 && (
          <>
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-gray-700">E mais bairros</h3>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-w-6xl mx-auto">
              {otherNeighborhoods.map((neighborhood) => (
                <Link
                  key={neighborhood}
                  to={`/${serviceType}-${slugify(neighborhood)}`}
                  className="flex items-center gap-3 p-4 bg-white rounded-lg hover:bg-[#00B4D8] hover:text-white transition-all duration-300 group shadow-sm border border-gray-100"
                >
                  <MapPin className="w-4 h-4 flex-shrink-0 text-[#00B4D8] group-hover:text-white" />
                  <span className="text-sm font-medium">{neighborhood}</span>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};
